import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, Output } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/observable/timer';
import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/takeUntil';
import { AssetPerson } from '../../models/employee-asset.model';
import { OffboardingAssigneeContext } from '../../models/offboarding.model';
import { OffboardingService } from '../../services/offboarding.service';
import { assetErrorKey, workflowTrackBy } from '../common/employee-assets/asset.helpers';

const SEARCH = {empty: '', min: 2, delay: 300};
@Component({selector: 'app-offboarding-person-search', templateUrl: './offboarding-person-search.component.html',
  styleUrls: ['./offboarding-sequential.component.css']})
export class OffboardingPersonSearchComponent implements OnChanges, OnDestroy {
  @Input() fieldId: string;
  @Input() labelKey: string;
  @Input() employees = false;
  @Input() context: OffboardingAssigneeContext;
  @Input() disabled = false;
  @Output() chosen = new EventEmitter<AssetPerson>();
  trackBy = workflowTrackBy;
  query = SEARCH.empty;
  people: AssetPerson[] = [];
  loading = false;
  searched = false;
  errorKey = SEARCH.empty;
  private request: Subscription;
  private destroyed = new Subject<void>();
  constructor(private api: OffboardingService, private changeDetectorRef: ChangeDetectorRef) {}
  ngOnChanges(): void { this.reset(); }
  ngOnDestroy(): void { this.cancel(); this.destroyed.next(); this.destroyed.complete(); }
  search(): void {
    this.cancel(); this.people = []; this.searched = false; this.errorKey = SEARCH.empty;
    const query = this.query.trim();
    if (this.disabled || query.length < SEARCH.min) { return; }
    this.loading = true;
    this.request = Observable.timer(SEARCH.delay).switchMap(() => this.api.options(query, this.context))
      .takeUntil(this.destroyed).subscribe(result => {
        this.people = (this.employees ? result.employees : result.assignees) || [];
        this.loading = false; this.searched = true;
        this.changeDetectorRef.markForCheck();
      }, error => { this.loading = false; this.errorKey = assetErrorKey(error, false); this.changeDetectorRef.markForCheck(); });
  }
  choose(person: AssetPerson): void { this.reset(); this.chosen.emit(person); }
  private reset(): void { this.cancel(); this.query = SEARCH.empty; this.people = []; this.searched = false; }
  private cancel(): void { if (this.request) { this.request.unsubscribe(); } this.loading = false; }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/offboarding/offboarding-person-search.component.ts